export default "__VITE_ASSET__8TuSS9Fs__"